import { NG_VALIDATORS, Validator } from '@angular/forms';
import { ValidaCpfService } from './../service/shared/valida-cpf.service';
import { Directive } from '@angular/core';

@Directive({
  selector: '[appValidaCpf][ngModel]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: ValidadorCpfDirective,
    multi: true
  }]
})
export class ValidadorCpfDirective extends ValidaCpfService implements Validator { }
